import { useEffect } from 'react';

export const useScript = (url, pageRef) => {
  useEffect(() => {
    const scriptTag = document.createElement('script');
    scriptTag.src = url;
    scriptTag.async = true;
    const node = pageRef ? pageRef.current : document.body;
    node.appendChild(scriptTag);
    return () => {
      node.removeChild(scriptTag);
    };
  }, [pageRef, url]);
};
